import React from "react";

const InputField = ({
  value,
  onChange,
  placeholder,
  handleKeyboardEvents,
  handleKeyboardUpEvents,
}) => (
  <input
    value={value}
    onChange={onChange}
    onKeyDown={handleKeyboardEvents}
    onKeyUp={handleKeyboardUpEvents}
    placeholder={placeholder}
    className="ml-[6px] min-w-0 flex-grow truncate bg-transparent p-2 pl-1 font-montserrat font-semibold uppercase text-text placeholder:text-text-muted focus:outline-none sm:ml-1 sm:p-0 sm:pl-3"
  />
);

export default InputField;
